import actions from './moduleSchoolExamNewActions.js'

export default {
    namespaced: true,
    actions
}
